:host {
  display: block;
}

uic-message-list {
  @media only screen and (min-width: 1920px) {
    --uic-message-list-item-width: 443px;
    --uic-message-list-header-height: 77px;
  }

  @media only screen and (max-width: 1919px) {
    --uic-message-list-item-width: 368px;
    --uic-message-list-header-height: 66px;
  }

  @media only screen and (max-width: 1023px) {
    --uic-message-list-item-width: 305px;
    --uic-message-list-header-height: 54px;
  }
}

.uic-message-list {
  &__flyout-head-content-1 {
    height: 20px;
  }

  &__flyout-head-content-1-container {
    align-items: center;
    display: flex;
  }

  &__header-spacer {
    width: 100%;
  }

  &__flyout-head-content-2 {
    font-family: OpenSans, sans-serif;
    font-weight: var(--uic-font-weight-semibold);
    height: 20px;
    margin-top: -4px;
  }

  &__flyout-min {
    background: var(--uic-color-white);
    box-shadow: 0 2px 4px 0 var(--uic-atom-shadow-color-primary), 0 2px 8px 0 var(--uic-atom-shadow-color-secondary);
    font-family: OpenSans, sans-serif;
    /*OpenSans-Regular*/
    height: 100%;
    position: relative;
    width: var(--uic-message-list-item-width);
  }

  &__flyout-head-min {
    color: var(--uic-color-black);
    font-size: var(--uic-font-size-normal);
    height: var(--uic-message-list-header-height);
    line-height: 20px;
    padding-left: 32px;
    padding-top: 13px;
  }

  &__flyout-content-min {
    border-top: 1px solid var(--uic-color-blue4);
  }

  &__messages-container-min {
    border-spacing: inherit;
    height: 100%;
    padding-left: 24px;
    padding-right: 24px;
    width: 100%;
  }

  &__flyout-footer-min {
    display: flex;
    flex-direction: column;
    padding-bottom: 22px;
    padding-left: calc((var(--uic-message-list-item-width) / 2) - 82px);
    padding-top: 19px;
    position: absolute;
    width: calc(var(--uic-message-list-item-width) / 2);
  }

  &__flyout-footer-label-min {
    bottom: 64px !important;
    color: var(--uic-color-blue4);
    cursor: pointer;
    font-size: var(--uic-font-size-normal);
    height: 23px;
    line-height: 23px;
    text-align: center;
    width: 187px;
    z-index: var(--uic-message-list-flyout-footer-label-z-index);
  }

  &__flyout-footer--label-text-min {
    border-bottom: 1px solid var(--uic-color-blue4);
  }

  &__flyout-head-max {
    color: var(--uic-color-black);
    font-size: var(--uic-font-size-normal);
    height: var(--uic-message-list-header-height);
    line-height: 20px;
    padding-left: 16px;
  }

  &__flyout-content-max {
    border-top: 1px solid var(--uic-color-blue4);
    height: calc(100% - var(--uic-message-list-header-height) - 2px);
    overflow-y: auto;
  }

  &__flyout-max {
    background: var(--uic-color-white);
    font-family: OpenSans, sans-serif;
    height: 100%;
    position: fixed;
    right: 0;
    /*OpenSans-Regular*/

    width: 100%;
    z-index: var(--uic-message-list-flyout-footer-z-index);

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: var(--uic-color-whitea95);
      box-shadow: 0 0 6px 0 var(--uic-color-blue6a20);
    }

    ::-webkit-scrollbar-thumb {
      background: var(--uic-color-blue2);
      border: 3px solid var(--uic-color-whitea95);
    }
  }

  &__output {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  &__output-content {
    border-bottom: 1px solid var(--uic-color-grey2);
    font-size: var(--uic-font-size-normal);
    font-style: italic;
    font-weight: normal;
    line-height: 1.3rem;
    padding-bottom: 9px;
    padding-left: 32px;
    padding-top: 10px;
  }

  &__flyout-history {
    border-bottom: 1px solid #000;
    height: 39px;
    width: 100%;

    .uic-message-list__flyout-text {
      color: #000;
      font-size: var(--uic-font-size-normal);
      font-weight: var(--uic-font-weight-extrabold);
      height: 18px;
      letter-spacing: 0;
      line-height: 18px;
      padding-bottom: 22px;
      padding-left: 24px;
      padding-top: 11px;
      width: 168px;
    }
  }

  &__type-filter {
    float: right;
    margin-right: 24px;
    position: sticky;
  }

  &__dropdown-space {
    margin-right: 8px;
  }
}
